import React, {Component} from 'react'
import ContentLoader from "react-content-loader"
import {
    MDBCarouselInner,
    MDBCarousel,
    MDBCarouselItem,
    MDBView,
    MDBMask,
    MDBCarouselCaption,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBAlert, MDBListGroupItem
} from "mdbreact";
import {connect} from "react-redux";
import classes from './DashBoard.module.css'
import firebase from "../../../../Config/firebase";
import {ListGroup} from "reactstrap";
import Post from "../../../../Component/PostList/Post/Post";
import {isAuth} from "../../../../Utils/firebaseUtils";
import PostMini from "../../../../Component/PostList/PostMini/PostMini";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import Jdenticon from "react-jdenticon";
import ListCommunity from "../../../../Component/Community/ListCommunity/ListCommunity";

const db = firebase.firestore()


class DashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPass: false,
            isBannerLoaded: false,
            banner: [],
            myPinData: []
        }
    }


    componentDidMount() {
        this.getBanner()
        if (isAuth(this.props.auth)) {
            this.getMyCollectionID(this.props.auth.uid)
        }
    }


    getBanner = () => {
        db.collection("Promote")
            .doc("Banner")
            .get()
            .then(doc => {
                    if (doc.exists) {
                        let allBanner = []
                        if (doc.data().hasOwnProperty("homeBanner")) {
                            doc.data().homeBanner.map(e => {
                                allBanner.push(e)
                            })
                            this.setState({
                                banner: allBanner
                            }, () => {
                                this.setState({
                                    isBannerLoaded: true
                                })
                            })
                        } else {
                            this.setState({
                                banner: []
                            }, () => {
                                this.setState({
                                    isBannerLoaded: true
                                })
                            })
                        }
                    } else {
                        this.setState({
                            banner: []
                        }, () => {
                            this.setState({
                                isBannerLoaded: true
                            })
                        })
                    }
                }
            )
            .catch(err => console.log(err))
    }

    getMyCollectionID = async (uid) => {
        db.collection('Member')
            .doc(uid)
            .collection('MyCollection')
            .where('isPinned', '==', true)
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allCollection = []
                    docs.forEach(function (doc) {
                        const collection = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allCollection.push(collection)
                    })
                    this.getMyCollectionPost(allCollection)
                } else {
                    this.setState({
                        myPinData: []
                    }, () => this.setState({
                        isLoaded: true
                    }))
                }

            })
    }
    getMyCollectionPost = async (allCollection) => {
        console.log(allCollection)
        allCollection.map(e => {
            db.collection('Post')
                .doc(e.postID)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        let allMyCollection = this.state.myPinData
                        const MyCollection = {
                            id: doc.id,
                            isPinned: e.isPinned,
                            collectionID: e.id,
                            ...doc.data()
                        }
                        allMyCollection.push(MyCollection)
                        this.setState({
                            myPinData: allMyCollection
                        }, () => this.setState({
                            isLoaded: true
                        }))
                    }

                })
        })
        console.log(this.state.myCollectionData)
    }


    render() {
        return (
            <MDBContainer className={classes.MyContainer}>
                <MDBRow>
                    <MDBCol size={12}>
                        <MDBCarousel
                            activeItem={1}
                            length={this.state.banner.length}
                            showControls={true}
                            showIndicators={true}
                            className={[classes.Carouse, "z-depth-1"].join(' ')}
                        >
                            <MDBCarouselInner>
                                {
                                    this.state.isBannerLoaded ?

                                        this.state.banner.map((e, index) => {
                                            return (
                                                <MDBCarouselItem itemId={index + 1} key={"mdbcar" + index}>
                                                    <MDBView key={"mdbView" + index}>
                                                        <a href={e.link} target="_blank">
                                                            <img
                                                                key={"mdbimg" + index}
                                                                className="d-block w-100"
                                                                src={e.image}
                                                                alt="First slide"
                                                            />
                                                            <MDBMask key={"mdbimgmask" + index} overlay="black-light"/>
                                                        </a>
                                                    </MDBView>
                                                    <MDBCarouselCaption key={"mdbcarcat" + index}
                                                                        className={classes.CarouselCaptionContainer}>
                                                        <a href={e.link} target="_blank">
                                                            <h3 key={"mdbcarcath3" + index} className="h3-responsive">
                                                                {e.title}
                                                            </h3>
                                                            <p key={"mdbcarcatp1" + index}>
                                                                {e.description}
                                                            </p>
                                                        </a>
                                                    </MDBCarouselCaption>
                                                </MDBCarouselItem>
                                            )
                                        })
                                        :
                                        <ContentLoader
                                            speed={2}
                                            width={window.offsetWidth - 100}
                                            height={500}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"

                                        >
                                            <rect x="-7" y="16" rx="0" ry="0" width="1200" height="600"/>
                                        </ContentLoader>
                                }

                            </MDBCarouselInner>
                        </MDBCarousel>

                        <div>
                            <h3 className={classes.PinnedPostTitle}>
                                熱門看板
                            </h3>
                            <ListGroup>
                                <Link to={{
                                    pathname: '/community/common',
                                }}
                                      key={'link common'}
                                >
                                    <MDBListGroupItem className={classes.MyCommunityItem}>
                                        <FontAwesomeIcon icon={faStar} className={classes.MyCommunityStar}/>
                                        <MDBRow className={classes.PostInf}>
                                            <MDBCol size={2}>
                                                <div className={classes.ImageContainer}>

                                                    <Jdenticon size="28" value={"common"}/>


                                                </div>
                                            </MDBCol>
                                            <MDBCol size={10}>

                                                吹水台

                                            </MDBCol>
                                        </MDBRow>
                                    </MDBListGroupItem>
                                </Link>
                                {/*<Link to={{*/}
                                {/*    pathname: '/community/debug',*/}
                                {/*}}*/}
                                {/*      key={'link Tmingler debug'}*/}
                                {/*>*/}
                                {/*    <MDBListGroupItem className={classes.MyCommunityItem}>*/}
                                {/*        <FontAwesomeIcon icon={faStar} className={classes.MyCommunityStar}/>*/}
                                {/*        <MDBRow className={classes.PostInf}>*/}
                                {/*            <MDBCol size={2}>*/}
                                {/*                <div className={classes.ImageContainer}>*/}

                                {/*                    <Jdenticon size="28" value={"debug"}/>*/}


                                {/*                </div>*/}
                                {/*            </MDBCol>*/}
                                {/*            <MDBCol size={10}>*/}

                                {/*                功能改善意見*/}

                                {/*            </MDBCol>*/}
                                {/*        </MDBRow>*/}
                                {/*    </MDBListGroupItem>*/}
                                {/*</Link>*/}
                            </ListGroup>
                        </div>

                        <div className={classes.IsMobile}>
                            <h3 className={classes.PinnedPostTitle}>
                                搜尋學校
                            </h3>
                            <ListCommunity/>
                        </div>

                        {
                            isAuth(this.props.auth) &&
                            <div>
                                <h3 className={classes.PinnedPostTitle}>
                                    已標記的貼文
                                </h3>
                                <ListGroup flush className={classes.PinnedPostContainer}>
                                    {
                                        this.state.isLoaded ?
                                            this.state.myPinData.length > 0 ?
                                                this.state.myPinData.map((post, index) => {
                                                    return (
                                                        <PostMini
                                                            key={index}
                                                            data={post}
                                                        />
                                                    )
                                                })
                                                :
                                                <MDBAlert color='light'>
                                                    你可以在文章右上方收藏貼文然後於
                                                    <Link to={'/m/collection'}>
                                                        標記貼文
                                                    </Link>
                                                </MDBAlert>
                                            : ''
                                    }
                                </ListGroup>
                            </div>
                        }


                        <main>
                            More
                        </main>

                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        );
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)


export default enhance(DashBoard)